"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faCheck } from "@fortawesome/free-solid-svg-icons";
import { Period } from "@/helpers/Types";
import { useAnimate } from "framer-motion";
interface DecisionPointDropdownProps {
  readonly value: Period;
  readonly onChange: (value: Period) => void;
}
export default function DecisionPointDropdown(t0) {
  const $ = _c(31);
  const {
    value,
    onChange
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const [iconScope, animateIcon] = useAnimate();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [{
      value: Period.WEEKS,
      label: "Weeks"
    }, {
      value: Period.DAYS,
      label: "Days"
    }, {
      value: Period.HOURS,
      label: "Hours"
    }];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const options = t1;
  let t2;
  if ($[1] !== value) {
    t2 = options.find(option => option.value === value) || options[0];
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const selectedOption = t2;
  let t3;
  if ($[3] !== animateIcon || $[4] !== iconScope || $[5] !== isOpen) {
    t3 = () => {
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 180
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      }
    };
    $[3] = animateIcon;
    $[4] = iconScope;
    $[5] = isOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== animateIcon || $[8] !== isOpen) {
    t4 = [isOpen, animateIcon];
    $[7] = animateIcon;
    $[8] = isOpen;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== onChange) {
    t5 = option_0 => {
      onChange(option_0.value);
      setIsOpen(false);
    };
    $[10] = onChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleSelect = t5;
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const handleClickOutside = event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t7 = [];
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== isOpen) {
    t8 = () => setIsOpen(!isOpen);
    $[14] = isOpen;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = selectedOption?.label;
  let t10;
  if ($[16] !== t9) {
    t10 = <span>{t9}</span>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== iconScope) {
    t11 = <div className="tw-pointer-events-none tw-flex tw-items-center"><FontAwesomeIcon ref={iconScope} icon={faChevronDown} className="tw-ml-2 tw-size-4 tw-transition-transform tw-duration-200" /></div>;
    $[18] = iconScope;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t8) {
    t12 = <button ref={buttonRef} type="button" aria-haspopup="true" onClick={t8} className="tw-flex tw-items-center tw-justify-between tw-w-full tw-bg-iron-800 lg:tw-bg-iron-900 tw-border-0 tw-rounded-r-lg tw-ring-1 tw-ring-inset tw-ring-iron-700 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 tw-text-iron-300 tw-px-3 tw-py-4 tw-text-sm tw-transition tw-duration-300 tw-ease-out">{t10}{t11}</button>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== handleSelect || $[25] !== isOpen || $[26] !== value) {
    t13 = isOpen && <div className="tw-absolute tw-z-10 tw-mt-1 tw-w-full tw-bg-iron-800 tw-border tw-border-iron-700 tw-rounded-lg tw-shadow-lg"><ul className="tw-list-none tw-mb-0 tw-py-2 tw-px-2">{options.map(option_1 => <li key={option_1.value} className="tw-h-full"><button type="button" onClick={() => handleSelect(option_1)} className="tw-flex tw-items-center tw-justify-between tw-w-full tw-px-3 tw-py-2.5 tw-text-sm tw-text-left hover:tw-bg-iron-700 tw-bg-transparent tw-border-none tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><div className="tw-flex tw-items-center"><span className="tw-text-sm tw-font-medium tw-text-white">{option_1.label}</span></div>{option_1.value === value && <FontAwesomeIcon icon={faCheck} className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" />}</button></li>)}</ul></div>;
    $[24] = handleSelect;
    $[25] = isOpen;
    $[26] = value;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12 || $[29] !== t13) {
    t14 = <div className="tw-relative tw-w-full" ref={dropdownRef}>{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}